export default {
  TRACKING_SORT: 'TRACKING_SORT',
  TRACKING_PENDING: 'TRACKING_PENDING',
  TRACKING_COMPLETE: 'TRACKING_COMPLETE',
  TRACKING_ERROR: 'TRACKING_ERROR',
}